import { useMemo } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Config } from "../../config";
import { CurrentUser } from "../../graphql/types";
import { useLocation } from "react-router-dom";
import { transformAuth0User } from "./auth0-user";
import { isInvalidRefreshToken } from "./oauth-error";
import { useLogout } from "./use-logout";
import { useApolloClient } from "@apollo/client";

export const useAuth = (srrHost?: string) => {
  const isBrowser = typeof window !== "undefined";

  const location = useLocation();

  const {
    error,
    isLoading,
    isAuthenticated,
    user,
    loginWithPopup,
    loginWithRedirect,
    logout: auth0Logout,
    getAccessTokenSilently,
  } = useAuth0();
  const currentUser: CurrentUser = useMemo(() => transformAuth0User(user), [user]);
  const [apiLogout] = useLogout();

  const apolloClient = useApolloClient();

  const { loginWithPopup: isLoginWithPopup } = Config.Auth0;

  const host = isBrowser ? window.location.hostname : srrHost;

  const isTestProduction =
    Config.testBaseUrl && host && host === Config.testBaseUrl.replace("https://", "");

  const auth0LoginCallBackUri = isTestProduction
    ? Config.testBaseUrl + "/login"
    : Config.baseUrl + "/login";

  const { returnTo = "/" } = (location.state || {}) as any;
  const login = () => {
    return isLoginWithPopup
      ? loginWithPopup({
          display: "touch",
          prompt: "login",
        })
      : loginWithRedirect({
          redirectUri: auth0LoginCallBackUri,
          appState: { returnTo },
        });
  };
  const logout = async () => {
    await apiLogout();
    auth0Logout({ returnTo: auth0LoginCallBackUri });
    apolloClient.clearStore();
  };
  const invalidToken = isInvalidRefreshToken(error);
  invalidToken && logout();
  return {
    error: invalidToken ? new Error("Login required, redirecting...") : error,
    isLoading,
    isAuthenticated,
    currentUser,
    login,
    logout,
    getAccessTokenSilently,
  };
};
